export * from './domains';
import { emailMisspelled } from './emailMisspelled';

export * from './typings';
export default emailMisspelled;
